// Route guard: out-of-scope routes render the same not-found as bad URLs —
// no scope leakage.
import type { ReactNode } from 'react'
import { useAuth } from './AuthProvider'
import type { Capability } from '../lib/types'
import { EmptyState } from '../components/ui'

export function NotFound() {
  return <EmptyState title="Page not found" hint="Check the link, or head back to My Shifts." />
}

export function RequireCapability({ capability, children }: { capability: Capability; children: ReactNode }) {
  const { can } = useAuth()
  if (!can(capability)) return <NotFound />
  return <>{children}</>
}
